<template>
  <div id="Grades" >
    <div class=" offset-md-3 col-md-6 offset-sm-2 col-sm-8 wrap" >
      <!-- Mobile App Bar -->
      <v-app-bar  class="grey lighten-3 d-md-none "  fixed  elevate-on-scroll  >
        <v-layout justify-center align-center>
          <v-icon  large color="blue darken-3">mdi-format-annotation-plus</v-icon>
          <span class="title blue--text text--darken-3 ml-1"> My Grades</span>
        </v-layout>
      </v-app-bar>

      <!-- Mobile Tabs -->
      <v-tabs-items hide-slider v-model="tab"  class="pb-0 mb-0 mt-4 d-md-none">
        <!-- My College GPA -->
        <v-tab-item>
          <v-layout row align-center >
              <v-layout column align-center>
                <v-progress-circular :width="3" size="100" :value=100 color="grey"> <span class="percentageValue display-1  font-weight-medium blue__text__color" >{{overallGpa.toFixed(2)}}</span></v-progress-circular>
                <p class="mt-2  grey--text">Overall</p>
              </v-layout>

              <v-layout column align-center>
                <v-progress-circular :width="3" size="100" :value=100 color="grey"> <span class="percentageValue  display-1 font-weight-medium blue__text__color">{{scienceGpa.toFixed(2)}}</span></v-progress-circular>
                <p class="mt-2 grey--text">Science</p>
              </v-layout>

              <v-layout column align-center>
                <v-progress-circular :width="3" size="100" :value=100 color="grey"> <span class="percentageValue  display-1  font-weight-medium blue__text__color ">{{nonscienceGpa.toFixed(2)}}</span></v-progress-circular>
                <p class="mt-2  grey--text">Non-Science</p>
              </v-layout>
          </v-layout>
        </v-tab-item>

        <!-- My CASPA GPA -->
        <v-tab-item>

          <v-layout row align-center >
                  <v-layout column align-center>
                    <v-progress-circular :width="3" size="100" :value=100 color="grey"> <span class="percentageValue display-1  blue__text__color font-weight-medium ">{{overallCaspaGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2  grey--text">Overall </p>
                  </v-layout>

                  <v-layout column align-center>
                    <v-progress-circular :width="3" size="100" :value=100 color="grey"> <span class="percentageValue  display-1 blue__text__color font-weight-medium ">{{scienceCaspaGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2  grey--text">Science</p>
                  </v-layout>

                  <v-layout column align-center>
                    <v-progress-circular :width="3" size="100" :value=100 color="grey"> <span class="percentageValue  display-1  blue__text__color font-weight-medium ">{{nonscienceCaspaGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2  grey--text">Non-Science</p>
                  </v-layout>
            </v-layout>
        </v-tab-item>
      </v-tabs-items>

      <v-tabs class="d-md-none" hide-slider v-model="tab" grow>
          <v-tab active-class="primary white--text" style="marginLeft:0px;">
          My College GPA
          </v-tab>

          <v-tab active-class="primary white--text">
            Projected CASPA GPA
          </v-tab>
      </v-tabs>

      <!-- Mobile My Colleges Container -->
      <v-container class="d-md-none" mt-5 px-0 pt-0 >
        <v-card flat outlined>

          <v-toolbar color="grey darken-3" dark flat>
              <v-toolbar-title>My Colleges</v-toolbar-title>
              <v-spacer></v-spacer>
              
            <v-btn  v-if="!checkUserLoggedIn || !checkUserIsSubscribed" class="mr-1 elevation-0 "  dark color="grey lighten-1">Add College</v-btn>
            <v-btn v-else @click="addCollege" class="mr-1 pa-2 elevation-6"  dark  color="#D49129">Add College</v-btn>
        
            </v-toolbar>


          <v-card-text class="px-1">

            <!-- Login or Signup Card -->
            <v-card v-if="!checkUserLoggedIn" class="elevation-0">

              <v-card-text class="text-center black--text">You need an active subscription to add a college</v-card-text>
                <v-card-actions>

                  <v-layout justify-center>
                    <v-btn to="/LoginSignupPage" style="width:40%"  class="elevation-0 mr-4" color="green" dark @click="showCreateSubscriptionDialog = false">
                          Login
                        </v-btn>


                        <v-btn to="/signup" style="width:40%"   class="elevation-0" color="primary" @click="showCreateSubscriptionDialog = false">
                          Signup
                        </v-btn>
                  </v-layout>

                </v-card-actions>
            </v-card>

            <!-- Active Subscription Card -->
            <v-card v-else-if="!checkUserIsSubscribed"  class="elevation-0">
                <v-card-text class="text-center black--text">You need an active subscription to add a college</v-card-text>
                <v-card-actions>

                  <v-layout justify-center>
                    <v-btn to="/myaccount" block class="elevation-0" color="primary" >
                                My Account
                              </v-btn>
                  </v-layout>

                </v-card-actions>
            </v-card>

            <!-- User Colleges -->
            <v-card  v-else class="  white " flat tile>

              <Colleges v-for="college in userColleges" :key="college.id" :college="college"/>


            <v-container v-if="userColleges.length === 0 && (user !== null && user !== undefined)" mt-3 pt-2>

              <p class="ml-2 text-center body-1 mt-1 pt-1 grey--text text--darken-4 font-weight-light">
                You have no College(s) saved. Add your college, semesters and courses to automatically calculate your GPA.

              </p>

            </v-container>

            </v-card>
          </v-card-text>

        </v-card>

               <div class="video-container">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/hqbDnP5wrpg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>


      </v-container>

      <!-- Back Button -->
      <v-btn  class="mr-4 ml-2  fixed elevation-0 d-md-none" color="red"  fab rounded small @click="back"> <v-icon  medium color="white">mdi-arrow-left</v-icon></v-btn>
    </div>

    
    <!-- Desktop Layout -->
    <div class="hidden-sm-and-down wrap" >
      <div class="mt-6">
        <v-row>

           <v-col>
              <!-- College GPA Card -->
              <v-card id="buttonShadow">
                <v-toolbar
                  color="primary"
                  dark
                  flat
                >
                  <v-toolbar-title>College GPA</v-toolbar-title>
                </v-toolbar>
                <v-layout row align-center class="mt-2">
                  <v-layout column align-center>
                    <v-progress-circular :width="2" size="85" :value=100 color="grey"> <span class="percentageValue display-1  blue__text__color font-weight-medium ">{{overallGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2 mb-1 grey--text">Overall</p>
                  </v-layout>

                  <v-layout column align-center>
                    <v-progress-circular :width="2" size="85" :value=100 color="grey"> <span class="percentageValue  display-1 blue__text__color font-weight-medium  ">{{scienceGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2 mb-1  grey--text">Science</p>
                  </v-layout>

                  <v-layout column align-center>
                    <v-progress-circular :width="2" size="85" :value=100 color="grey"> <span class="percentageValue  display-1  blue__text__color font-weight-medium  ">{{nonscienceGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2 mb-1  grey--text">Non-Science</p>
                  </v-layout>
                </v-layout>
              </v-card>
           </v-col>

              <v-col>
              <!-- CASPA GPA Card -->
              <v-card id="buttonShadow">
                <v-toolbar
                color="primary"
                dark
                flat>
                  <v-toolbar-title>Projected CASPA GPA</v-toolbar-title>
                </v-toolbar>
                <v-layout row align-center class="mt-2">
                  <v-layout column align-center>
                    <v-progress-circular :width="2" size="85" :value=100 color="grey"> <span class="percentageValue display-1  blue__text__color  font-weight-medium">{{overallCaspaGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2 mb-1 grey--text">Overall </p>
                  </v-layout>

                  <v-layout column align-center>
                    <v-progress-circular :width="2" size="85" :value=100 color="grey"> <span class="percentageValue  display-1 blue__text__color font-weight-medium ">{{scienceCaspaGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2 mb-1 grey--text">Science</p>
                  </v-layout>

                  <v-layout column align-center>
                    <v-progress-circular :width="2" size="85" :value=100 color="grey"> <span class="percentageValue  display-1  blue__text__color  font-weight-medium">{{nonscienceCaspaGpa.toFixed(2)}}</span></v-progress-circular>
                    <p class="mt-2 mb-1 grey--text">Non-Science</p>
                  </v-layout>
                </v-layout>
              </v-card>
           </v-col>

        </v-row>
         <!-- My Colleges Card -->
        <v-flex xs12 class="mt-5">
          <v-card flat outlined>
            <v-toolbar
              color="grey darken-3"
              dark
              flat
              >
              <v-toolbar-title>My Colleges</v-toolbar-title>
              <v-spacer></v-spacer>

              <v-btn  v-if="!checkUserLoggedIn || !checkUserIsSubscribed"  class="mr-1 elevation-0 "  dark color="grey lighten-1">Add College</v-btn>
              <v-btn v-else  @click="addCollege" class="mr-1 pa-2 elevation-6"  dark  color="#D49129">Add College</v-btn>

            </v-toolbar>
            <v-card-text>
              <!-- Login or Signup Card -->
              <v-card  v-if="!checkUserLoggedIn" class="elevation-0">

                <v-card-text class="text-center black--text">You need an active subscription to add a college</v-card-text>
                  <v-card-actions>

                    <v-layout justify-center>
                      <v-btn to="/LoginSignupPage" style="width:40%"  class="elevation-0 mr-4" color="green" dark @click="showCreateSubscriptionDialog = false">
                            Login
                          </v-btn>


                          <v-btn to="/signup" style="width:40%"   class="elevation-0" color="primary" @click="showCreateSubscriptionDialog = false">
                            Signup
                          </v-btn>
                    </v-layout>

                  </v-card-actions>
              </v-card>

              <!-- Active Subscription Card -->
              <v-card v-else-if="!checkUserIsSubscribed" class="elevation-0">
                  <v-card-text class="text-center black--text">You need an active subscription to add a college</v-card-text>
                  <v-card-actions>

                    <v-layout justify-center>
                      <v-btn to="/myaccount" block class="elevation-0" color="primary" >
                                  My Account
                                </v-btn>
                    </v-layout>

                  </v-card-actions>
              </v-card>
              <div v-else-if="checkUserLoggedIn && checkUserIsSubscribed">
                <Colleges v-for="college in userColleges" :key="college.id" :college="college"/>

                <v-container v-if="userColleges.length === 0 && (user !== null && user !== undefined)" mt-3 pt-2>

                  <p class="ml-2 text-center body-1 mt-1 pt-1 grey--text text--darken-4 font-weight-light">
                    You have no College(s) saved. Add your college, semesters and courses to automatically calculate your GPA.

                  </p>

                </v-container>
              </div>

              
            </v-card-text>

          </v-card>
          <div class="video-container">
                <iframe width="560" height="315" src="https://www.youtube.com/embed/hqbDnP5wrpg" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
        </v-flex>
      </div>
    </div>

  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import userMixins from '@/mixins/usersmixin'
export default {
  mixins: [userMixins],
  data() {
    return {
      tab: null,
      addCollegeMenu: false,
      showModal: false,
      menu2: false,
      menu3: false,
      AddCollegeDialog: false,
      college_name: "",
      degree: "In Progress",
      college_start_date: "",
      college_term_system: "",
      college_degree_awarded: "",
      college_graduation_date: "",
      dialog: false,
        notifications: false,
        sound: true,
        widgets: false,
    };
  },
   mounted() {
      document.querySelector('.v-slide-group__prev--disabled').style.flexBasis = 0
      document.querySelector('.v-slide-group__prev--disabled').style.minWidth = 0
    },
    methods: {
      back() {
        this.$router.push("/dashboard");
      },
      addCollege() {
        this.$router.push("/dashboard/mygrades/addcollege");

      }
    },
};
</script>

<style scoped>
.video-container {
    position: relative;
    padding-bottom: 56.25%;
    padding-top: 35px;
    height: 0;
    overflow: hidden;
    
}


.video-container iframe {
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 80%;
    box-shadow: 0 10px 20px -10px rgba(0,0,0,.19) !important;
    border-radius: 5px;
    margin-top:30px;
}
@media (min-width: 960px) {
 
  .container {
    max-width: 80%;
  }
}
.link {
  text-decoration: none;
}

.signupOrLoginContainer {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 120px;
}

.subtitle {
  color: rgb(85, 85, 85);
}

.text {
  font-size: 20px;
  color: rgb(85, 85, 85);
  margin-top: 20px;
}



.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 90%;
  margin: 0px auto;

  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
  transition: all 0.3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
  color: #42b983;
}

.modal-body {
  margin: 20px 0;
}

.modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

#header {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}

#buttonShadow {
  box-shadow: 0 10px 30px -10px rgba(0,0,0,.19);
}
 .fixed {
    position: fixed;
    bottom: 0;
    right: 0;
    margin-bottom:65px;

  }


.blue__text__color {
  color:#005880;
}


@media (max-width: 900px) {
  .wrap {
    margin-top: 8vh !important;
    
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Grades.vue